import { useEffect } from 'react';

import { useCurrentUser, useCurrentWorkspaceId, usePerformanceActions } from 'src/store';

/**
 * This hook is used to maintain the performance store state.
 */
export const useMaintainPerformanceStoreState = () => {
  useMaintainCommonStoreState();
};

const useMaintainCommonStoreState = () => {
  const currentUser = useCurrentUser();
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    performanceActions.queryWorkspaceResources(currentWorkspaceId);
    performanceActions.queryWorkspaceAccounts(currentWorkspaceId);

    return () => {
      performanceActions.cancelWaitRequests();
    };
  }, [performanceActions, currentWorkspaceId]);

  const confirmedUserId = currentUser?.isConfirmed ? currentUser.id : null;
  useEffect(() => {
    if (!confirmedUserId) {
      return;
    }

    performanceActions.queryChannelsAuthState();
    performanceActions.queryUserIntegrationAccounts(confirmedUserId);

    return () => {
      performanceActions.cancelWaitRequests();
      performanceActions.clearStore();
    };
  }, [performanceActions, confirmedUserId]);
};
